import React from 'react';
import { FourItemsContainer, FourItem } from './FourItems.styles';
import {
  FaShieldAlt,
  FaCheckCircle,
  FaCertificate,
  FaUserTie,
} from 'react-icons/fa';

const FourItems = () => {
  return (
    <FourItemsContainer>
      <FourItem>
        <FaShieldAlt />

        <div>
          <h4>WCB Approved Provider</h4>
          <p>Recognized workplace safety training and compliance support.</p>
        </div>
      </FourItem>

      <FourItem>
        <FaCheckCircle />

        <div>
          <h4>Fully Insured</h4>
          <p>Trusted coverage and professional operational standards.</p>
        </div>
      </FourItem>

      <FourItem>
        <FaCertificate />

        <div>
          <h4>ISO 9001:2015 Certified</h4>
          <p>Committed to quality management and continuous improvement.</p>
        </div>
      </FourItem>

      <FourItem>
        <FaUserTie />

        <div>
          <h4>Certified Trainers & Auditors</h4>
          <p>Experienced professionals supporting safer workplaces.</p>
        </div>
      </FourItem>
    </FourItemsContainer>
  );
};

export default FourItems;
